import { RouteRecordRaw } from "vue-router";

const sidebarName = "SidebarIssueMonitoring";

export const issueMonitoringRoutes: RouteRecordRaw[] = [
  {
    path: "/issue-monitoring",
    component: () => import("@/views/common/Home.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/issue-monitoring/samplingpoints",
    component: () => import("@/views/issueMonitoring/IssueSamplingPoint.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/issue-monitoring/list",
    component: () => import("@/views/issueMonitoring/IssueList.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
];
